inputs-checkbox-multiple
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      span(each="{item, namespace in opts.items}")
        .checkbox-fade.fade-in-primary
          label
            input(type="hidden" value="0" name="{ item.name }" )
            input(if="{ item.value == '1' }" type="checkbox" value="1" name="{ item.name }" onClick="{ this.onChange }" data-id="{namespace}" checked="checked")
            input(if="{ item.value != '1' }" type="checkbox" value="1" name="{ item.name }" onClick="{ this.onChange }" data-id="{namespace}")
            span.cr
              i.cr-icon.icofont.icofont-ui-check.txt-primary
            span { item.label }
      div.help-block(if="{ opts.errors }")
        ul(role="alert")
          li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.checkbox-multiple');
